import debounce from '../../debounce'

export default {
    props: {
        src: {
            type: String,
            required: true
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        muted: {
            type: Boolean,
            default: true
        },
        shrinked: {
            type: Boolean,
            default: true
        },
        openLabel: {
            type: String,
            default: 'Open'
        },
        closeLabel: {
            type: String,
            default: 'Close'
        },
        light: {
            type: Boolean,
            default: false
        },
        relative: {
            type: Boolean,
            default: false
        },
        preventAside: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        dragging: false,
        dragged: false,
        dragOrigin: undefined,
        dragDelta: undefined,
        dragInnerOrigin: undefined,
        dragPosition: undefined,
        viewport: undefined,

        loading: false,
        paused: false,
        ended: undefined,
        error: false,
        secondsRemaining: 0,

        primaryUIVisible: false,
        primaryUITimeout: undefined,

        show: false,
    }),
    created() {
        // URL parameters
        const urlLSQ = new URLSearchParams(window.location.search).get('lsq')

        // Session storage
        const sessionLSQ = sessionStorage.getItem('showLSQ')

        this.show = urlLSQ == 'false' ? false : (urlLSQ == 'true' || sessionLSQ === 'true')
    },
    mounted() {
        this.updateStatus()
    },
    methods: {
        mousedown(e) {
            if(!this.draggable) {
                return
            }

            // prevent right click
            if(e.which && ![0,1].includes(e.which)) {
                e.preventDefault()
                return
            }
            if(e.touches) e = e.touches[0]

            this.dragging = true
            this.dragged = false
            this.dragStartTime = Date.now()

            this.dragOrigin = {
                x: e.clientX,
                y: e.clientY
            }
            this.dragInnerOrigin = this.$refs.inner.getBoundingClientRect()

            this.dragArea = this.$el.getBoundingClientRect()

            gsap.set(this.$refs.placeholder, { width: this.dragInnerOrigin.width, height: this.dragInnerOrigin.height })
        },
        mousemove(e) {
            if(!this.draggable) {
                return
            }

            if(e.touches) {
                if(this.dragging) {
                    e.preventDefault()
                    e.stopPropagation()
                }

                e = e.touches[0]
            }

            if(this.dragging) {

                this.dragDelta = {
                    x: e.clientX - this.dragOrigin.x,
                    y: e.clientY - this.dragOrigin.y
                }

                const dragDeltaDistance = Math.sqrt(Math.pow(0 - this.dragDelta.x, 2) + Math.pow(0 - this.dragDelta.y, 2))

                if(dragDeltaDistance > 10) {
                    this.dragged = true

                    this.dragPosition = {
                        top: this.dragInnerOrigin.top + this.dragDelta.y,
                        left: this.dragInnerOrigin.left + this.dragDelta.x
                    }

                    gsap.set(this.$refs.inner, {
                        top: this.dragInnerOrigin.top,
                        left: this.dragInnerOrigin.left,
                        bottom: 'initial',
                        right: 'initial',
                        x: this.dragDelta.x,
                        y: this.dragDelta.y,
                        force3D: true,
                        pointerEvents: 'none'
                    })
                } else {
                    gsap.set(this.$refs.inner, { clearProps: 'x,y,pointerEvents' })
                }
            }
        },
        mouseup(e) {
            if(!this.draggable) {
                return
            }

            if(e.touches) e = e.touches[0]

            if(!this.dragged) {
                this.dragging = false
                return
            }

            const targetBCR = this.$refs.placeholder.getBoundingClientRect()
            this.dragArea = this.$el.getBoundingClientRect()

            const animationDelta = {
                x: this.dragPosition.left - targetBCR.left,
                y: this.dragPosition.top - targetBCR.top,
            }
            this.dragging = false

            gsap.set(this.$refs.inner, {
                clearProps: 'top,left,right,bottom,pointerEvents'
            })

            gsap.fromTo(this.$refs.inner, {
                x: animationDelta.x,
                y: animationDelta.y
            }, {
                x: 0,
                y: 0
            })
        },
        toggleMute() {
            this.$refs.video.muted = !this.$refs.video.muted
        },
        togglePlay() {
            if(this.paused) {
                this.play()
            } else {
                this.pause()
            }
        },
        play() {
            this.$refs.video.play()
        },
        pause() {
            this.$refs.video.pause()
        },
        toggleShrink() {
            this.shrinked = !this.shrinked
        },
        toggleVisibility() {
            this.show = !this.show

            if(!this.show) {
                this.pause()
            } else {
                this.play()
            }
        },
        updateStatus(e) {
            if(this.paused && !this.$refs.video.paused) { // on play
                this.hidePrimaryUI()
            } else if(!this.paused && this.$refs.video.paused) { // on pause
                this.showPrimaryUI()
            }

            this.paused = this.$refs.video.paused
            this.ended = this.$refs.video.ended

            this.loading = [0,1,2,3].includes(this.$refs.video.readyState)

            this.error = this.$refs.video.error

            if(this.ended) {
                this.$emit('ended')
            }
        },
        updateVolume() {
            this.muted = this.$refs.video.muted
        },
        updateTime() {
            this.secondsRemaining = this.$refs.video.duration - this.$refs.video.currentTime
        },
        showPrimaryUI() {
            clearTimeout(this.primaryUITimeout)
            this.primaryUIVisible = true
        },
        hidePrimaryUI() {
            clearTimeout(this.primaryUITimeout)
            this.primaryUITimeout = setTimeout(() => {
                this.primaryUIVisible = false
            }, 1000)
        },
        onMouseMove() {
            this.showPrimaryUI()

            if(!this.paused) {
                this.hidePrimaryUI()
            }
        },
        // showSecondaryUI() {
        //     this.secondaryUiVisible = true
        // },
        // hideSecondaryUI() {
        //     this.secondaryUiVisible = false
        // },

        // // checkForError() {
        // //     if([1,3].includes(this.$refs.video.networkState)) {
        // //         const errorMessages = {
        // //             0: 'NETWORK_EMPTY',
        // //             3: 'NETWORK_NO_SOURCE'
        // //         }
        // //         this.error = errorMessages[this.$refs.video.networkState]
        // //     } else {
        // //         this.error = false
        // //     }
        // // }
    },
    computed: {
        draggable() {
            return !this.relative
        },
        reversed() {
            if(!this.dragPosition || !this.dragArea) return false

            const center = this.dragArea.width / 2 - this.dragInnerOrigin.width / 2
            return this.dragPosition.left < center
        },
        timeRemaining() {
            if(!this.secondsRemaining) return false

            let h = Math.floor(this.secondsRemaining / 3600)
            let m = Math.floor(this.secondsRemaining % 3600 / 60)
            let s = ('0' + Math.round(this.secondsRemaining % 3600 % 60)).slice(-2)

            return '-'+(h > 0 ? h+':' : '') + m + ':' + s
        },
    },
    watch: {
        show() {
            sessionStorage.setItem('showLSQ', this.show);
        }
    },
    template: `
        <div class="c-lsq u-anim -opacity -delay-1" :class="[{ '-dragging': dragging, '-reversed': reversed, '-shrinked': shrinked, '-light': light, '-relative': relative, '-prevent-aside': preventAside }]">
            <div v-show="show || relative" class="c-lsq_wrap" @mouseup="mouseup" @mousemove="mousemove" @touchmove="mousemove" @touchend="mouseup">
                <div class="c-lsq_inner" ref="inner" @mousedown="mousedown" @touchstart="mousedown">
                    <figure class="c-lsq_player" @mousemove="onMouseMove">
                        <div class="c-lsq_player_ui">
                            <button class="c-lsq_player_mute" @click="toggleMute">
                                <template v-if="muted">
                                    <span class="u-screen-reader-text">Activer le son</span>
                                    <svg role="img"><use href="assets/images/sprite.svg#mute"></use></svg>
                                </template>
                                <template v-else>
                                    <span class="u-screen-reader-text">Désactiver le son</span>
                                    <svg role="img"><use href="assets/images/sprite.svg#unmute"></use></svg>
                                </template>
                            </button>
                            <button class="c-lsq_player_play" :class="{ '-visible': primaryUIVisible }" @click="togglePlay">
                                <transition name="v-transition-fade" mode="out-in">
                                    <span v-if="error" class="c-lsq_player_error">
                                        <span>{{error.message}}</span>
                                    </span>
                                    <template v-else>
                                        <template v-if="!paused">
                                            <span>
                                                <span class="u-screen-reader-text">Pause</span>
                                                <svg role="img"><use href="assets/images/sprite.svg#pause"></use></svg>
                                            </span>
                                        </template>
                                        <template v-else-if="loading">
                                            <span>
                                                <span class="u-screen-reader-text">Chargement...</span>
                                                <span class="c-lsq_player_spinner"></span>
                                            </span>
                                        </template>
                                        <template v-else-if="ended">
                                            <span>
                                                <span class="u-screen-reader-text">Rejouer</span>
                                                <svg role="img"><use href="assets/images/sprite.svg#replay"></use></svg>
                                            </span>
                                        </template>
                                        <template v-else-if="paused">
                                            <span>
                                                <span class="u-screen-reader-text">Lecture</span>
                                                <svg role="img"><use href="assets/images/sprite.svg#play"></use></svg>
                                            </span>
                                        </template>
                                    </template>
                                </transition>
                            </button>
                            <span aria-hidden="true" class="c-lsq_player_time" v-if="timeRemaining" v-show="!shrinked && !ended">{{timeRemaining}}</span>
                        </div>
                        <video
                            ref="video"
                            :src="src+'#t=0.5'"
                            class="c-lsq_player_video"
                            playsinline
                            :poster="$refs.video && [2,3,4].includes($refs.video.readyState) ? false : '/assets/videos/placeholder.jpg'"
                            preload="metadata"
                            :autoplay="autoplay"
                            :muted="muted"
                            @playing="updateStatus"
                            @pause="updateStatus"
                            @loadstart="updateStatus"
                            @waiting="updateStatus"
                            @seeking="updateStatus"
                            @canplay="updateStatus"
                            @volumechange="updateVolume"
                            @ended="updateStatus"
                            @timeupdate="updateTime"
                            @error="updateStatus"
                        ></video>
                    </figure>

                    <button v-if="!relative" class="c-lsq_shrink" @click="toggleShrink">
                        <svg v-if="shrinked" role="img"><use href="/assets/images/sprite.svg#expand"></use></svg>
                        <svg v-else role="img"><use href="/assets/images/sprite.svg#shrink"></use></svg>
                    </button>

                    <button v-if="!relative" class="c-lsq_close" @click="toggleVisibility">
                        <span class="u-screen-reader-text">{{ closeLabel }}</span>
                        <svg role="img"><use href="/assets/images/sprite.svg#close"></use></svg>
                    </button>
                </div>
                <div class="c-lsq_placeholder" ref="placeholder" v-show="dragging"></div>
            </div>

            <button v-show="!show && !relative" class="c-lsq_open" @click="toggleVisibility">
                <span>
                    <svg role="img"><use href="assets/images/sprite.svg#lsq"></use></svg>
                </span>
                <span class="u-label">
                    LSQ
                </span>
                <p class="u-screen-reader-text">{{ openLabel }}</p>
            </button>
        </div>
    `
}
